(function () {
  'use strict';
  var T = window.theme || { strings: {} };
  var S = T.strings || {};
  var root = T.root || '/';
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  function money(c) {
    try { return new Intl.NumberFormat(T.locale || 'es-ES', { style: 'currency', currency: T.currency || 'EUR' }).format(c / 100); }
    catch (e) { return (c / 100).toFixed(2) + ' €'; }
  }
  function json(url, opts) { return fetch(url, opts).then(function (r) { return r.json(); }); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = $$('.reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Drawers (menu / search / cart) ---------- */
  function openDrawer(el) { if (!el) return; el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); document.body.classList.add('no-scroll'); var f = $('input,button,a', el.querySelector('.drawer__panel')); }
  function closeDrawer(el) { if (!el) return; el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); if (!$('.drawer.is-open')) document.body.classList.remove('no-scroll'); }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var mo = t.closest('[data-menu-open]'); if (mo) { e.preventDefault(); openDrawer($('[data-menu]')); return; }
    var so = t.closest('[data-search-open]'); if (so) { e.preventDefault(); openDrawer($('[data-search]')); var i = $('[data-search] input'); if (i) setTimeout(function () { i.focus(); }, 250); return; }
    var co = t.closest('[data-cart-open]'); if (co && $('[data-cart-drawer]')) { e.preventDefault(); refreshCart().then(function () { openDrawer($('[data-cart-drawer]')); }); return; }
    var cc = t.closest('[data-cart-close],[data-drawer-close]'); if (cc) { closeDrawer(cc.closest('.drawer')); return; }
    var tt = t.closest('[data-totop]'); if (tt) { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
    var qa = t.closest('[data-quick-add]'); if (qa) { e.preventDefault(); addItems([{ id: +qa.getAttribute('data-quick-add'), quantity: 1 }]); return; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { $$('.drawer.is-open').forEach(closeDrawer); closeVideo(); closePopup(); }
  });

  /* ---------- Header: sticky class + back to top ---------- */
  var totop = $('[data-totop]');
  window.addEventListener('scroll', function () { if (totop) totop.classList.toggle('is-visible', window.scrollY > 700); }, { passive: true });

  /* ---------- Announcement rotator ---------- */
  $$('[data-announce]').forEach(function (bar) {
    var items = $$('.announce__item', bar); if (items.length < 2) return;
    var i = 0; bar.setAttribute('data-ready', ''); items[0].classList.add('is-active');
    setInterval(function () { items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }, +bar.getAttribute('data-speed') * 1000 || 4500);
  });

  /* ---------- Countdowns ---------- */
  function initCountdowns() {
    var els = $$('[data-countdown-hours],[data-countdown-end]'); if (!els.length) return;
    function target(el) {
      var fixed = el.getAttribute('data-countdown-end');
      if (fixed) { var d = Date.parse(fixed.replace(' ', 'T')); if (!isNaN(d) && d > Date.now()) return d; }
      var h = +el.getAttribute('data-countdown-hours') || 24, key = 'cl_cd_' + h, end = 0;
      try { end = +sessionStorage.getItem(key) || 0; } catch (e) {}
      if (!end || end < Date.now()) { end = Date.now() + h * 3600000; try { sessionStorage.setItem(key, end); } catch (e) {} }
      return end;
    }
    var ends = els.map(target);
    function tick() {
      els.forEach(function (el, i) {
        var left = ends[i] - Date.now();
        if (left <= 0) { ends[i] = target(el); left = ends[i] - Date.now(); }
        var s = Math.floor(left / 1000), h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60);
        el.textContent = pad(h) + ':' + pad(m) + ':' + pad(s % 60);
      });
    }
    tick(); setInterval(tick, 1000);
  }

  /* ---------- Cart ---------- */
  var cartEl = $('[data-cart-drawer]');
  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; c.setAttribute('data-zero', cart.item_count ? '0' : '1'); });
    if (!cartEl) return cart;
    var body = $('[data-cart-items]', cartEl), foot = $('[data-cart-foot]', cartEl), ship = $('[data-cart-ship]', cartEl);
    if (!cart.items.length) {
      ship.innerHTML = '';
      body.innerHTML = '<div class="cart-empty"><p><strong>' + esc(S.empty) + '</strong></p><button type="button" class="btn btn--primary" data-cart-close>' + esc(S.continueShopping) + '</button></div>';
      foot.innerHTML = ''; return cart;
    }
    var th = +T.freeShipping || 0;
    if (th > 0) {
      var left = th - cart.total_price, pct = Math.min(100, Math.round(cart.total_price / th * 100));
      ship.innerHTML = '<div>' + (left > 0 ? esc(S.freeLeft).replace('__AMOUNT__', money(left)) : esc(S.freeDone)) + '</div><div class="ship-bar"><span style="width:' + pct + '%"></span></div>';
    } else ship.innerHTML = '';
    body.innerHTML = cart.items.map(function (it, idx) {
      var img = it.featured_image && it.featured_image.url ? '<img src="' + esc(it.featured_image.url) + '" alt="" width="76" height="76" loading="lazy">' : '<span></span>';
      var v = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="citem__var">' + esc(it.variant_title) + '</div>' : '';
      var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      return '<div class="citem"><a href="' + esc(it.url) + '">' + img + '</a><div><div class="citem__title">' + esc(it.product_title) + '</div>' + v +
        '<div class="qty"><button type="button" data-qty="' + (idx + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="-">−</button><span>' + it.quantity + '</span><button type="button" data-qty="' + (idx + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="+">+</button></div>' +
        '<button type="button" class="citem__remove" data-qty="' + (idx + 1) + '" data-q="0">' + esc(S.remove) + '</button></div>' +
        '<div class="citem__price">' + money(it.final_line_price) + was + '</div></div>';
    }).join('');
    var sav = cart.total_discount > 0 ? '<div class="cart-save"><span>' + esc(S.savings) + '</span><span>−' + money(cart.total_discount) + '</span></div>' : '';
    var note = T.cartNote ? '<div class="cart-note"><textarea data-cart-note placeholder="' + esc(S.note) + '" aria-label="' + esc(S.note) + '">' + esc(cart.note || '') + '</textarea></div>' : '';
    foot.innerHTML = note + sav + '<div class="cart-total"><span>' + esc(S.subtotal) + '</span><span>' + money(cart.total_price) + '</span></div><p class="small">' + esc(S.taxes) + '</p>' +
      '<a class="btn btn--primary btn--block btn--xl" href="' + root + 'checkout">' + esc(S.checkout) + '</a>';
    return cart;
  }
  function refreshCart() { return json(root + 'cart.js').then(renderCart); }
  function addItems(items) {
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || S.error); return d; }); })
      .then(function () { return refreshCart(); })
      .then(function () { if (cartEl) openDrawer(cartEl); else window.location = root + 'cart'; });
  }
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-qty]'); if (!q) return;
    fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: +q.getAttribute('data-qty'), quantity: Math.max(0, +q.getAttribute('data-q')) }) })
      .then(function (r) { return r.json(); }).then(renderCart);
  });
  var noteTimer;
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-cart-note]')) return;
    clearTimeout(noteTimer); var v = e.target.value;
    noteTimer = setTimeout(function () { fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: v }) }); }, 600);
  });

  /* ---------- Gallery ---------- */
  function initGallery(g) {
    var track = $('[data-track]', g); if (!track) return;
    var slides = $$('.gallery__slide', track), dots = $$('[data-dot]', g);
    function idx() { return Math.round(track.scrollLeft / (track.clientWidth || 1)); }
    function go(i) { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
    track.addEventListener('scroll', function () { var i = idx(); dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); }); }, { passive: true });
    var p = $('[data-prev]', g), n = $('[data-next]', g);
    if (p) p.addEventListener('click', function () { go(idx() - 1); });
    if (n) n.addEventListener('click', function () { go(idx() + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    g.goToMedia = function (id) { var i = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(id); }); if (i > -1) go(i); };
  }

  /* ---------- Buy box (packs, designs, extras, add to cart) ---------- */
  function initBuy(main) {
    var form = $('[data-buybox]', main); if (!form) return;
    var packs = $$('[data-pack]', form), btn = $('[data-atc]', form), err = $('[data-buy-error]', form);
    var gallery = $('[data-gallery]', main);
    function current() { return packs.filter(function (p) { return p.classList.contains('is-selected'); })[0] || packs[0]; }
    function calc() {
      var pack = current(), n = +pack.getAttribute('data-pack'), d = +pack.getAttribute('data-discount') || 0, sum = 0;
      $$('select[data-unit]', pack).forEach(function (s, i) { if (i < n && s.selectedOptions[0]) sum += +s.selectedOptions[0].getAttribute('data-price'); });
      var total = Math.round(sum * (100 - d) / 100);
      $$('[data-extra]:checked', pack).forEach(function (c) { total += +c.getAttribute('data-price'); });
      var out = $('[data-atc-total]', btn); if (out) out.textContent = money(total);
      var sb = $('[data-sticky-total]'); if (sb) sb.textContent = money(total);
    }
    function select(pack) {
      packs.forEach(function (p) { p.classList.toggle('is-selected', p === pack); var r = $('[data-pack-radio]', p); if (r) r.checked = (p === pack); });
      calc();
    }
    packs.forEach(function (p) {
      $('[data-pack-radio]', p).addEventListener('change', function () { select(p); });
      p.addEventListener('click', function (e) { if (!p.classList.contains('is-selected') && !e.target.closest('label')) select(p); });
    });
    form.addEventListener('change', function (e) {
      var s = e.target.closest('select[data-unit]');
      if (s) {
        var o = s.selectedOptions[0], thumb = $('[data-design-thumb]', s.closest('.design'));
        if (thumb && o.getAttribute('data-thumb')) thumb.src = o.getAttribute('data-thumb');
        if (gallery && gallery.goToMedia && o.getAttribute('data-media')) gallery.goToMedia(o.getAttribute('data-media'));
      }
      var x = e.target.closest('[data-extra]');
      if (x) $$('[data-extra="' + x.getAttribute('data-extra') + '"]', form).forEach(function (o2) { o2.checked = x.checked; });
      calc();
    });
    function submit(e) {
      if (e) e.preventDefault();
      if (btn.disabled) return;
      var pack = current(), n = +pack.getAttribute('data-pack'), map = {}, items = [];
      $$('select[data-unit]', pack).forEach(function (s, i) { if (i < n) map[s.value] = (map[s.value] || 0) + 1; });
      Object.keys(map).forEach(function (id) { items.push({ id: +id, quantity: map[id] }); });
      $$('[data-extra]:checked', pack).forEach(function (c) { items.push({ id: +c.value, quantity: 1 }); });
      var code = pack.getAttribute('data-code');
      btn.disabled = true; if (err) err.hidden = true;
      var pre = code ? fetch(root + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {}) : Promise.resolve();
      pre.then(function () { return addItems(items); })
        .catch(function (ex) { if (err) { err.textContent = ex.message || S.error; err.hidden = false; } })
        .then(function () { btn.disabled = false; });
    }
    form.addEventListener('submit', submit);
    var sticky = $('[data-sticky]'), sbtn = sticky && $('[data-sticky-btn]', sticky);
    if (sbtn) sbtn.addEventListener('click', function () { submit(); });
    if (sticky && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        var visible = en[0].isIntersecting, below = en[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', !visible && below);
      });
      io.observe(btn);
    }
    calc();
  }

  /* ---------- Delivery estimate & viewers ---------- */
  function initDelivery() {
    $$('[data-delivery]').forEach(function (el) {
      var mn = +el.getAttribute('data-min') || 3, mx = +el.getAttribute('data-max') || 6;
      function add(days) { var d = new Date(), n = 0; while (n < days) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n++; } return d; }
      function f(d) { return d.toLocaleDateString(T.locale || 'es-ES', { day: 'numeric', month: 'long' }); }
      var t = $('[data-delivery-text]', el); if (t && S.delivery) t.textContent = S.delivery.replace('__FROM__', f(add(mn))).replace('__TO__', f(add(mx)));
    });
    $$('[data-viewers]').forEach(function (el) {
      var mn = +el.getAttribute('data-min') || 12, mx = +el.getAttribute('data-max') || 40, tpl = el.getAttribute('data-tpl');
      function set() { el.textContent = tpl.replace('__N__', Math.floor(Math.random() * (mx - mn + 1)) + mn); }
      set(); setInterval(set, 9000);
    });
  }

  /* ---------- FAQ (one open at a time) ---------- */
  document.addEventListener('toggle', function (e) {
    var d = e.target; if (!d.matches || !d.matches('.faq__item') || !d.open) return;
    var list = d.closest('[data-single]'); if (!list) return;
    $$('.faq__item[open]', list).forEach(function (o) { if (o !== d) o.open = false; });
  }, true);

  /* ---------- Videos ---------- */
  function initVideos() {
    var inline = $$('video[data-vsrc]'); if (!inline.length) return;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        var v = x.target;
        if (x.isIntersecting) { if (!v.src) v.src = v.getAttribute('data-vsrc'); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { threshold: 0.4 });
    inline.forEach(function (v) { v.muted = true; io.observe(v); });
  }
  var modal = $('[data-vmodal]');
  function closeVideo() { if (!modal || modal.hidden) return; modal.hidden = true; $('[data-vmodal-body]', modal).innerHTML = ''; document.body.classList.remove('no-scroll'); }
  function embedUrl(u) {
    var m;
    if ((m = u.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{6,})/))) return { iframe: 'https://www.youtube.com/embed/' + m[1] + '?autoplay=1&rel=0&playsinline=1' };
    if ((m = u.match(/vimeo\.com\/(?:video\/)?(\d+)/))) return { iframe: 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1' };
    return { file: u };
  }
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-video-open]');
    if (card && modal) {
      var src = card.getAttribute('data-video-open'); if (!src) return;
      var body = $('[data-vmodal-body]', modal), r = embedUrl(src);
      body.innerHTML = r.iframe ? '<iframe src="' + esc(r.iframe) + '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>' : '<video src="' + esc(r.file) + '" controls autoplay playsinline></video>';
      var cta = $('[data-vmodal-cta]', modal), url = card.getAttribute('data-product-url');
      if (cta) { cta.hidden = !url; if (url) { cta.href = url; cta.textContent = S.buy || 'Buy'; } }
      modal.hidden = false; document.body.classList.add('no-scroll'); return;
    }
    if (e.target.closest('[data-vmodal-close]')) closeVideo();
  });

  /* ---------- Newsletter popup ---------- */
  var popup = $('[data-popup]');
  function closePopup() { if (!popup || popup.hidden) return; popup.hidden = true; try { localStorage.setItem('cl_popup', '1'); } catch (e) {} }
  if (popup) {
    var seen = false; try { seen = !!localStorage.getItem('cl_popup'); } catch (e) {}
    if (location.search.indexOf('customer_posted') > -1) seen = false;
    if (!seen) setTimeout(function () { popup.hidden = false; }, (+popup.getAttribute('data-delay') || 8) * 1000);
    popup.addEventListener('click', function (e) { if (e.target.closest('[data-popup-close]')) closePopup(); });
  }

  /* ---------- Social proof toast ---------- */
  var toast = $('[data-toast]');
  if (toast) {
    var names = []; try { names = JSON.parse(toast.getAttribute('data-names')) || []; } catch (e) {}
    names = names.map(function (n) { return n.trim(); }).filter(Boolean);
    if (names.length) {
      var show = function () {
        var n = names[Math.floor(Math.random() * names.length)], m = Math.floor(Math.random() * 25) + 2;
        $('[data-toast-title]', toast).textContent = (S.toastBought || '').replace('__NAME__', n);
        $('[data-toast-time]', toast).textContent = (S.toastAgo || '').replace('__MIN__', m);
        toast.hidden = false; setTimeout(function () { toast.hidden = true; }, 5500);
      };
      setTimeout(function () { show(); setInterval(show, 30000); }, 12000);
    }
  }

  /* ---------- Predictive search ---------- */
  var sInput = $('[data-search] input[type=search]'), sOut = $('[data-search-results]'), sTimer;
  if (sInput && sOut) {
    sInput.addEventListener('input', function () {
      clearTimeout(sTimer); var q = sInput.value.trim();
      if (q.length < 2) { sOut.innerHTML = ''; return; }
      sTimer = setTimeout(function () {
        json(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6').then(function (d) {
          var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
          sOut.innerHTML = ps.length ? ps.map(function (p) {
            return '<li><a href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" width="56" height="56">' : '<span></span>') + '<span><strong>' + esc(p.title) + '</strong><br>' + esc(p.price ? money(Math.round(parseFloat(p.price) * 100)) : '') + '</span></a></li>';
          }).join('') : '<li class="small">' + esc(S.noResults) + '</li>';
        }).catch(function () {});
      }, 250);
    });
  }

  /* ---------- Product recommendations ---------- */
  $$('[data-recs]').forEach(function (el) {
    fetch(el.getAttribute('data-recs')).then(function (r) { return r.text(); }).then(function (t) {
      var doc = new DOMParser().parseFromString(t, 'text/html'), inner = $('[data-recs-inner]', doc);
      if (inner && inner.innerHTML.trim()) { el.innerHTML = inner.innerHTML; initReveal(); } else el.closest('section').hidden = true;
    }).catch(function () {});
  });

  /* ---------- Collection filters ---------- */
  $$('[data-filter-form]').forEach(function (f) { f.addEventListener('change', function () { f.submit(); }); });
  $$('[data-sort]').forEach(function (s) { s.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', s.value); location.href = u.toString(); }); });

  /* ---------- Init ---------- */
  function init() {
    initReveal(); initCountdowns(); initDelivery(); initVideos();
    $$('[data-gallery]').forEach(initGallery);
    $$('[data-product-main]').forEach(initBuy);
    if (cartEl) refreshCart();
    if (document.body.classList.contains('template-product') && $('[data-sticky]')) document.body.style.paddingBottom = '76px';
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
